module.exports = __webpack_public_path__ + "img/damir-pro.ec613aed.jpg";